import { FC, useState } from 'react'
import cn from 'clsx'
import { CaretLeft, CloseIconLarge } from '@components/icons'

interface NavMenuL2Props {
  menuItem: any
  isMobile: boolean
  closeMenu?: any
  backButtonClick?: any
  closeL2Menu?: any
  isOpen: boolean
  categoryId: number
}

interface L2NavItemsProps {
  items: any
  closeMenu?: any
}

const ns = `nav-menu-l2`

const L2NavItems: FC<L2NavItemsProps> = ({ items, closeMenu }) => {
  return items.map((item: any) => (
    <li key={item.label} className={`${ns}__primary-nav-item`}>
      {item.label && (
        <>
          <a href={item.target} onClick={closeMenu}>
            <p className={`${ns}__nav-link-label`}>{item.label}</p>
          </a>
        </>
      )}
    </li>
  ))
}

const NavMenuL2: FC<NavMenuL2Props> = ({
  menuItem = {},
  closeMenu,
  isOpen,
  backButtonClick,
  isMobile,
  closeL2Menu,
  categoryId,
}) => {
  const { hideCategoryTitleOnDesktop, linkListCollection = {} } = menuItem
  const linkItems = linkListCollection.items || []
  const topPosition = 154 + categoryId * 51.5
  return (
    <div
      className={cn(`${ns}`, { '--open': isOpen })}
      onMouseLeave={closeL2Menu}
      style={!isMobile ? { paddingTop: `${topPosition}px` } : {}}
    >
      {isMobile && (
        <h4
          className={cn(`${ns}__nav-title`, {
            space: !isMobile && hideCategoryTitleOnDesktop,
          })}
        >
          {(isMobile || !hideCategoryTitleOnDesktop) && menuItem.categoryTitle}
        </h4>
      )}
      <ul className={`${ns}__nav-item-wrapper`}>
        <L2NavItems items={linkItems} closeMenu={closeMenu} />
      </ul>
    </div>
  )
}

export default NavMenuL2
